export default __webpack_public_path__ + "static/media/medal.3c52e3d3.svg";